module.exports = __webpack_public_path__ + "img/1080_21.133c028d.jpg";